// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"56590219","10064":"56590219","19742":"56590219","23383":"7e020c72","31712":"56590219","51339":"56590219","76297":"56590219","77566":"56590219","94446":"56590219"}[chunkId] + ".chunk.css";
};